var map = {
	"./4g.svg": 53539,
	"./5g.svg": 86496,
	"./accessible.svg": 70146,
	"./activity-level.svg": 40570,
	"./add-sim.svg": 46883,
	"./addressbook-add.svg": 27841,
	"./addressbook.svg": 45383,
	"./ads-off.svg": 49318,
	"./ai.svg": 63298,
	"./alarm-filled.svg": 71216,
	"./alarm.svg": 84975,
	"./alert-round.svg": 41901,
	"./alert.svg": 90530,
	"./apple.svg": 78824,
	"./arrow-down-circle.svg": 1437,
	"./arrow-down-double.svg": 49302,
	"./arrow-down.svg": 62576,
	"./arrow-download.svg": 78252,
	"./arrow-left-circle.svg": 30300,
	"./arrow-left.svg": 37119,
	"./arrow-leftwards.svg": 28896,
	"./arrow-reply.svg": 58048,
	"./arrow-right-circle.svg": 48007,
	"./arrow-right.svg": 1114,
	"./arrow-rightwards.svg": 7235,
	"./arrow-round-circle.svg": 40321,
	"./arrow-up-circle.svg": 36448,
	"./arrow-up-down.svg": 63256,
	"./arrow-up.svg": 73251,
	"./arrow-upload.svg": 95,
	"./attach.svg": 58791,
	"./backspace.svg": 73261,
	"./backup.svg": 71202,
	"./bank.svg": 95602,
	"./battery.svg": 60591,
	"./bed.svg": 33517,
	"./best.svg": 95906,
	"./birthday.svg": 65475,
	"./briefcase.svg": 71196,
	"./broadband.svg": 50329,
	"./business-services.svg": 75303,
	"./calendar-14.svg": 25460,
	"./calendar-24.svg": 81661,
	"./calendar-31.svg": 40359,
	"./calendar-close.svg": 95605,
	"./calendar.svg": 50586,
	"./camera.svg": 42165,
	"./car.svg": 81442,
	"./cart.svg": 13522,
	"./chart-pie.svg": 95185,
	"./chart.svg": 67488,
	"./chat.svg": 60330,
	"./check-circle.svg": 62461,
	"./check-round.svg": 12847,
	"./check.svg": 4240,
	"./cherry.svg": 25951,
	"./christmas.svg": 77188,
	"./close-round.svg": 53603,
	"./close.svg": 96412,
	"./cloud.svg": 91139,
	"./coins.svg": 69374,
	"./compare.svg": 23765,
	"./computer.svg": 87043,
	"./contact-business.svg": 32711,
	"./contact-care.svg": 64342,
	"./contact-check.svg": 12455,
	"./contact-edit.svg": 34709,
	"./contact-family.svg": 45113,
	"./contact-lock.svg": 30836,
	"./contact.svg": 56980,
	"./conversation.svg": 74669,
	"./copy.svg": 27967,
	"./couch.svg": 93746,
	"./currency-euro.svg": 89137,
	"./device-digibox.svg": 29561,
	"./device-insurance.svg": 11181,
	"./device-laptop-check.svg": 58496,
	"./device-router.svg": 62316,
	"./device-stb-1.svg": 35910,
	"./device-stb-2.svg": 58341,
	"./device-stb-3.svg": 90820,
	"./devices-mobile.svg": 25628,
	"./devices.svg": 94689,
	"./digitark-round.svg": 89214,
	"./digitark.svg": 21977,
	"./diil.svg": 92382,
	"./download.svg": 64216,
	"./dsl-hub.svg": 96099,
	"./edit.svg": 53628,
	"./education.svg": 82170,
	"./email-write.svg": 74726,
	"./email.svg": 61808,
	"./entertainment-film-sport.svg": 95128,
	"./entertainment-film.svg": 68637,
	"./entertainment.svg": 11218,
	"./esim.svg": 8754,
	"./eu-et.svg": 94808,
	"./eu-ru.svg": 47620,
	"./eu-sliced-et.svg": 91353,
	"./eu-sliced-ru.svg": 90181,
	"./eu-sliced.svg": 89585,
	"./eu.svg": 50082,
	"./euro-in-box.svg": 933,
	"./explore.svg": 76325,
	"./f4g.svg": 98421,
	"./face-sad.svg": 97664,
	"./face-smile.svg": 44192,
	"./facebook-round.svg": 24499,
	"./facebook.svg": 42092,
	"./facemask.svg": 799,
	"./fiber.svg": 96054,
	"./file-bill.svg": 44960,
	"./file-check-simple.svg": 34992,
	"./file-check.svg": 45561,
	"./file-close.svg": 40213,
	"./file-contact.svg": 34029,
	"./file-csv.svg": 58321,
	"./file-doc.svg": 30731,
	"./file-edit.svg": 19367,
	"./file-pdf.svg": 44299,
	"./file-ppt.svg": 41357,
	"./file-settings.svg": 44340,
	"./file-xls.svg": 88294,
	"./file.svg": 61082,
	"./filter.svg": 38934,
	"./fingerprint.svg": 11660,
	"./folder.svg": 84172,
	"./follow-up.svg": 70335,
	"./football.svg": 97451,
	"./fullscreen-in.svg": 51841,
	"./fullscreen-out.svg": 99504,
	"./games.svg": 59177,
	"./gate.svg": 68973,
	"./gif.svg": 89930,
	"./google-play.svg": 20512,
	"./grid-view.svg": 40998,
	"./hand-button.svg": 35864,
	"./hand-euro.svg": 32991,
	"./handshake.svg": 17603,
	"./hbo.svg": 39433,
	"./heart-line-pulse.svg": 96767,
	"./heart-line.svg": 17883,
	"./heart.svg": 50564,
	"./help.svg": 62585,
	"./hijack.svg": 26956,
	"./home-care.svg": 14997,
	"./home-services.svg": 86694,
	"./home.svg": 56189,
	"./hot-drink.svg": 12844,
	"./huawei-app-gallery.svg": 35148,
	"./id.svg": 30095,
	"./info-round.svg": 36267,
	"./inspira-plus-hor.svg": 76359,
	"./instagram-round.svg": 5075,
	"./instagram.svg": 74924,
	"./internet-topup.svg": 44258,
	"./internet-up-down.svg": 70660,
	"./ip.svg": 26579,
	"./job-search.svg": 12982,
	"./jpg.svg": 35373,
	"./key.svg": 47141,
	"./laptop.svg": 34492,
	"./like.svg": 26969,
	"./link.svg": 43800,
	"./linkedin-round.svg": 5033,
	"./linkedin.svg": 67702,
	"./list-view.svg": 34142,
	"./listen.svg": 8977,
	"./live-alt.svg": 61756,
	"./live.svg": 91206,
	"./lock-open.svg": 79314,
	"./lock.svg": 72781,
	"./login.svg": 3199,
	"./logo-dpd.svg": 72430,
	"./logo-eurosport.svg": 18357,
	"./logo-foxplay.svg": 81671,
	"./logo-go3.svg": 16159,
	"./logo-hbomax-hor.svg": 82251,
	"./logo-hbomax-ver.svg": 70867,
	"./logo-inspira-plus.svg": 45513,
	"./logo-inspira.svg": 97376,
	"./logo-itella.svg": 7707,
	"./logo-netflix.svg": 35886,
	"./logo-omniva.svg": 98082,
	"./logo-setanta-app.svg": 71156,
	"./logo-setanta.svg": 36894,
	"./logo-tiktok.svg": 68644,
	"./logo-wolt.svg": 63524,
	"./logout.svg": 96970,
	"./magazine.svg": 39634,
	"./map-marker.svg": 28937,
	"./matryoshka.svg": 41005,
	"./megaphone.svg": 42026,
	"./menu-burger.svg": 52561,
	"./microsoft.svg": 38196,
	"./minus-round.svg": 72463,
	"./minus.svg": 41040,
	"./mobile-24h.svg": 45171,
	"./mobile-48h.svg": 58001,
	"./mobile-5h.svg": 91056,
	"./mobile-arrow-up.svg": 75500,
	"./mobile-infinity.svg": 9515,
	"./mobile-play.svg": 69862,
	"./mobile-recycle.svg": 2866,
	"./mobile-renew.svg": 4450,
	"./mobile-repair.svg": 62748,
	"./mobile-sale.svg": 8738,
	"./mobile-spy.svg": 11599,
	"./mobile-wifi.svg": 9216,
	"./mobile-world.svg": 22393,
	"./mobile.svg": 59902,
	"./monitor.svg": 48218,
	"./more-grid.svg": 17132,
	"./more-vertical.svg": 18546,
	"./more.svg": 59187,
	"./music.svg": 16249,
	"./myaccount.svg": 64183,
	"./nature.svg": 94729,
	"./network.svg": 55370,
	"./new-window.svg": 25579,
	"./newcontact.svg": 17986,
	"./newgroup.svg": 98483,
	"./no-stroller-access.svg": 41022,
	"./no-stroller.svg": 86935,
	"./no-tv.svg": 45176,
	"./not-accessible.svg": 38718,
	"./offering.svg": 50990,
	"./offers.svg": 97125,
	"./office.svg": 94760,
	"./overview.svg": 17897,
	"./packet-adults.svg": 20742,
	"./packet-discovery.svg": 20389,
	"./packet-disney.svg": 25577,
	"./packet-est-channel.svg": 90373,
	"./packet-hd.svg": 6009,
	"./packet-info-tv.svg": 52868,
	"./packet-news.svg": 79260,
	"./packet-ng.svg": 196,
	"./packet-tv3.svg": 3478,
	"./parcel-machine.svg": 2915,
	"./password-hide.svg": 28004,
	"./password-show.svg": 73303,
	"./pause.svg": 88166,
	"./pay-once.svg": 53704,
	"./people.svg": 21705,
	"./percentage.svg": 82760,
	"./phone-and-mobile.svg": 65039,
	"./phone-arrow-left-right.svg": 81355,
	"./phone-dial.svg": 27115,
	"./phone-favorite.svg": 17585,
	"./phone-lock.svg": 3652,
	"./phone-message.svg": 80814,
	"./phone-wifi.svg": 33514,
	"./phone.svg": 2564,
	"./pin.svg": 27381,
	"./pingpong.svg": 70902,
	"./plane.svg": 9686,
	"./play-circle.svg": 40931,
	"./play-infinity.svg": 62579,
	"./play-line.svg": 86005,
	"./play.svg": 88550,
	"./plus-round.svg": 58727,
	"./plus.svg": 18904,
	"./power-plug.svg": 18888,
	"./print.svg": 10605,
	"./protect.svg": 71173,
	"./pulse.svg": 4723,
	"./record.svg": 87031,
	"./recycle.svg": 68447,
	"./refresh.svg": 30961,
	"./register.svg": 52283,
	"./reload.svg": 96551,
	"./remote-admin.svg": 84520,
	"./repair.svg": 99719,
	"./report.svg": 33806,
	"./return.svg": 55802,
	"./rocket.svg": 6344,
	"./save.svg": 1535,
	"./savings.svg": 76837,
	"./search.svg": 24052,
	"./security-camera.svg": 15358,
	"./security.svg": 58618,
	"./send.svg": 23522,
	"./server-domain.svg": 60826,
	"./server.svg": 69553,
	"./service-add.svg": 8019,
	"./service-control.svg": 34373,
	"./service-devices.svg": 47503,
	"./service-info-tv.svg": 46029,
	"./service-internet-check.svg": 50422,
	"./service-internet.svg": 51585,
	"./service-other.svg": 54848,
	"./service-smart-wifi.svg": 49881,
	"./service-tv-4k.svg": 8214,
	"./service-tv-channels.svg": 65977,
	"./service-tv-check.svg": 57983,
	"./service-tv-hd.svg": 15261,
	"./service-tv-packet.svg": 32861,
	"./service-tv-pause.svg": 21449,
	"./service-tv-ppv.svg": 1285,
	"./settings.svg": 44335,
	"./share.svg": 25681,
	"./shop.svg": 63879,
	"./shuffle.svg": 26091,
	"./signature.svg": 13278,
	"./sim.svg": 46973,
	"./skip-backward-10.svg": 27953,
	"./skip-backward-30.svg": 15771,
	"./skip-backward.svg": 53489,
	"./skip-forward-10.svg": 21145,
	"./skip-forward-30.svg": 11587,
	"./skip-forward.svg": 75961,
	"./smart-id.svg": 8875,
	"./sms.svg": 89487,
	"./snowflake.svg": 81364,
	"./sort.svg": 36276,
	"./sound.svg": 63445,
	"./space.svg": 66986,
	"./sport.svg": 50462,
	"./spotify.svg": 93814,
	"./spyware.svg": 45249,
	"./star-line.svg": 60343,
	"./star.svg": 70376,
	"./stethoscope.svg": 66351,
	"./stocks-up.svg": 1961,
	"./stream.svg": 84696,
	"./stroller.svg": 45653,
	"./subtitles.svg": 16839,
	"./suhtlus.svg": 84840,
	"./summary.svg": 30336,
	"./support.svg": 28925,
	"./sustainability.svg": 78719,
	"./sync.svg": 225,
	"./table-view.svg": 71154,
	"./tablet.svg": 92456,
	"./tag.svg": 85912,
	"./technician.svg": 30298,
	"./teddybear.svg": 77660,
	"./telia-pebble-round.svg": 38161,
	"./telia-pebble.svg": 92142,
	"./telia-tv.svg": 27480,
	"./telia1.svg": 54622,
	"./terminal.svg": 20112,
	"./thinking.svg": 64296,
	"./thunder.svg": 46894,
	"./time-close.svg": 44664,
	"./time-quarter.svg": 73160,
	"./time-round.svg": 45524,
	"./trailer.svg": 47345,
	"./transfer.svg": 66617,
	"./transport-fast.svg": 16874,
	"./transport.svg": 74055,
	"./trashcan-empty.svg": 57196,
	"./trashcan.svg": 77016,
	"./travel.svg": 20444,
	"./tv-favorites.svg": 12082,
	"./tv-play.svg": 88757,
	"./tv-screen.svg": 62879,
	"./tv-telia-live.svg": 30419,
	"./tv-viewslot.svg": 57504,
	"./tv.svg": 35170,
	"./twitter-round.svg": 54506,
	"./twitter.svg": 29082,
	"./upload.svg": 10355,
	"./user-group.svg": 70271,
	"./vcard.svg": 7472,
	"./video.svg": 52665,
	"./viewslot-1.svg": 25857,
	"./viewslot-2.svg": 44114,
	"./viewslot-3.svg": 93507,
	"./viewslot-4.svg": 65852,
	"./viewslot-5.svg": 78045,
	"./volume.svg": 98470,
	"./wallet.svg": 93559,
	"./watch.svg": 45489,
	"./weather.svg": 53060,
	"./wireless-offline.svg": 26370,
	"./wireless.svg": 37936,
	"./world.svg": 46556,
	"./zoom-in.svg": 74063,
	"./zoom-out.svg": 11162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1174;